module.exports = __webpack_public_path__ + "static/img/dadi2026Banner3.5600fbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/haierProduct/images/dadi2026Banner3.png
// module id = NVhI
// module chunks = 4